import React from "react";

interface ErrorType {
  error: any;
  errorInfo: any;
}
export default class ErrorBoundary extends React.Component<any, ErrorType> {
  static getDerivedStateFromError(error: any) {
    return { error };
  }
  constructor(props: any) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }
  componentDidCatch(error: any, errorInfo: any) {
    this.setState({
      error,
      errorInfo,
    });
  }
  render() {
    if (this.state.error) {
      console.log("this.state.errorInfo", this.state.errorInfo);
      return (
        <div>
          <h3>{this.state.error && this.state.error.toString()}</h3>
          <p>{this.state.errorInfo && this.state.errorInfo.componentStack}</p>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}
